// Module
var code = `<template>
  <require from="./nav-widget.scss"></require>
  <global-progress if.bind="loading" size="50" stroke-width="5"></global-progress>
  <div if.bind="!loading && !error" class="nav-widget nav-widget-\${id}">

    <!-- beautify ignore:start -->
    <style>
      .nav-widget-\${id} {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    \${totals.netAssetValueAdjusted | numericFormatter:'0,0'}
  </div>
  <message if.bind="error" icon="error" colour="mdc-theme--error" class="nav-widget__error">
    \${error.message}</message>
</template>
`;
// Exports
export default code;